import React from 'react';
import styled from 'styled-components';
import { Form as AntForm, FormProps as AntFormProps } from 'antd';

type FormProps = Omit<AntFormProps, 'children'> & { children?: React.ReactNode };

const StyledForm = styled(AntForm)`
  flex: 1;
`;
const StyledFormItem = styled(AntForm.Item)`
    @media (max-width: 1280px) {
      margin-bottom: calc(var(--spacing-small) * 2);
    }
`;

const Form: React.FC<FormProps> & {
  useForm: typeof AntForm.useForm;
  useWatch: typeof AntForm.useWatch;
  Item: typeof StyledFormItem;
  List: typeof AntForm.List;
  Provider: typeof AntForm.Provider;
  ErrorList: typeof AntForm.ErrorList;
} = (props:any) => <StyledForm {...props} />;

// Assigning all static properties and methods of AntForm to the custom Form component
Form.useForm = AntForm.useForm;
Form.useWatch = AntForm.useWatch;
Form.Item = StyledFormItem;
Form.List = AntForm.List;
Form.Provider = AntForm.Provider;
Form.ErrorList = AntForm.ErrorList;

export default Form;
